<div class="card__header">
  <h2>Criar usuário a partir de um já existente</h2>
  <span class="close-btn material-icons" (click)="closeSideNav()"> close </span>
</div>

<section class="card__section">
  <pl-alert color="success">
    <span header>Usuário criado com sucesso!</span>
    <span content>
      Uma senha temporária foi enviada para o e-mail <br />
      <strong>{{ (details$ | async)?.alternativeEmail?.email }}</strong
        >.
      </span>
    </pl-alert>
    <pl-info-card [showStatusBar]="false"></pl-info-card>
    <pl-alert
      class="information"
      color="warning"
      display="block"
      >
      <span content>
        O novo usuário pode levar até 15 minutos para aparecer na listagem de usuários, mas seu acesso ao Menu de Produtos já está disponível.
      </span>
    </pl-alert>
  </section>

  @if (details$ | async; as logon) {
    <pl-action-footer>
      <div class="details__footer action-footer">
        <seds-basic-button
          title="Concluir"
          (click)="closeSideNav()"
        ></seds-basic-button>
      </div>
    </pl-action-footer>
  }
